import axios from 'axios';
import { getBackendURL } from '../../Utils/ServerURL';
import { STARTING_TABLE_PAGE, DEFAULT_ROWS_PER_PAGE, ORDER_BY_BRAND_DESCRIPTION, ORDER_ASCENDING } from '../../Utils/Constants';
const sControllerEndpoint = 'BrandModel';


export class AdminBrandModelAPI {

  getAdminTableData(page = STARTING_TABLE_PAGE, rowsPerPage = DEFAULT_ROWS_PER_PAGE, orderBy = ORDER_BY_BRAND_DESCRIPTION, order = ORDER_ASCENDING, searchBy = '', availabilityStateId = 0) {
    let params = {
      page: page,
      rowsPerPage: rowsPerPage,
      orderBy: orderBy,
      order: order,
      availabilityStateId: availabilityStateId,
    }
    if (searchBy)
      params.searchBy = searchBy;
    return axios.get(getBackendURL() + sControllerEndpoint + '/GetDataForTable', { params });
  }

  postExcelFile(formData) {
    return axios.post(getBackendURL() + sControllerEndpoint, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  }

}

export default AdminBrandModelAPI


// WEBPACK FOOTER //
// ./src/API/Admin/AdminBrandModelAPI.js